import React, { useState } from 'react';
import _ from 'lodash';
import axios, { AxiosResponse } from 'axios';
import Card from '../atoms/Card';
import Message, { StatusMessageType } from '../atoms/Message';
import { useForm, FieldValues } from 'react-hook-form';

function handleConfirmChangePlan (
  subscriptionId: string,
  planId: string,
  setStatusMessage: (statusMessage: StatusMessageType) => void,
  setIsChangingPlan: (isChangingPlan: boolean) => void,
  setChangePlanSuccess: (changePlanSuccess: boolean) => void,
) {
    axios
      .post(
        '/apis/microsoft/subscriptions/update_plan/',
        {
          planId,
          subscriptionId,
        },
      )
      .then(
        (res: AxiosResponse) => {
          if (res.data.status === 'OK') {
            setStatusMessage({
              type: 'success',
              message: 'Plan changed successfully. Please refresh the page to see the updates.',
            });
            setIsChangingPlan(false);
            setChangePlanSuccess(true);
          } else {
            setStatusMessage({
              type: 'warning',
              message: 'Could not verify the plan was changed. Please refresh the page and try again.',
            });
            setIsChangingPlan(false);
          }
        },
        (reason: any) => {
          setStatusMessage({
            type: 'error',
            message: reason,
          });
          setIsChangingPlan(false);
        },
      );
}

const ChangePlanCard = ({
  currentPlan,
  planData,
  subscriptionId,
}:{
  currentPlan: string;
  planData: any;
  subscriptionId: string;
}): JSX.Element => {
  const {
    handleSubmit,
    register,
  } = useForm();
  const [isChangingPlan, setIsChangingPlan] = useState(false);
  const [changePlanSuccess, setChangePlanSuccess] = useState(false);
  const [statusMessage, setStatusMessage] = useState<StatusMessageType>();

  function onSubmit (values: FieldValues) {
    const planId = values.planId;
    if (planId === currentPlan) {
      setStatusMessage({
        type: 'error',
        message: 'The plan selected is the current plan. Please choose another plan.'
      });
    } else {
      handleConfirmChangePlan(
        subscriptionId,
        planId,
        setStatusMessage,
        setIsChangingPlan,
        setChangePlanSuccess,
      );
    }
  }

  return (
    <>
      {
        !isChangingPlan
          ? 
            <button
              type="button"
              className="my-2 mr-2"
              onClick={
                () => {
                  setIsChangingPlan(true);
                }
              }
              disabled={changePlanSuccess}
            >
              {
                changePlanSuccess
                  ? 'Plan Changed Successfully'
                  : 'Change Plan'
              }
            </button>
          : 
            <Card theme="dark" className="mt-4 mb-4">
              <h2 className="mt-0">Choose a New Plan</h2>
              <form onSubmit={ handleSubmit(onSubmit) }>
                {
                  _.map(planData, (plan, i) => {
                    const isCurrentPlan = plan.planId === currentPlan;
                    return (
                      <label
                        className="block mb-2"
                        key={i}
                      >
                        <input
                          value={plan.planId}
                          type="radio"
                          {...register('planId')}
                          defaultChecked={isCurrentPlan}
                        />
                        <strong>{plan.displayName}</strong> {isCurrentPlan && <em>(current plan)</em>}
                        {plan.description && <span className="block mt-1">Description: {plan.description}</span>}
                      </label>
                    );
                  })
                }
                <button
                  className="mr-2 mb-0"
                  type="submit"
                >
                  Confirm Plan Change
                </button>
                <button
                  className="mr-2 mb-0"
                  type="button"
                  onClick={
                    () => {
                      setIsChangingPlan(false);
                    }
                  }
                >
                  Cancel
                </button>
              </form>
            </Card>
      }
      {
        statusMessage &&
          <Message
            theme="dark"
            type={statusMessage.type}
          >
            {statusMessage.message}
          </Message>
      }
    </>
  );
};

export default ChangePlanCard;
